import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/soluciones/life-cycle-management")({
  head: () => buildRouteHead("/es/soluciones/life-cycle-management", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/soluciones/operational-excellence", replace: true });
  },
});
